require("dotenv").config();

const apihostname = process.env.REACT_APP_API;
// const apihostname = "http://regsugarcane02.ocsb.go.th:3000";
// const apihostname = "https://regsugarcane02.ocsb.go.th:3000";

// const hostname = "http://regsugarcane02.ocsb.go.th:8081"
export default apihostname;
